const EmployeePointRecord = () => import('@/views/main/helper/employeePointRecord/EmployeePointRecord.vue')
export default {
  path: '/main/helper/employeePointRecord',
  name: 'EmployeePointRecord',
  component: EmployeePointRecord,
  children: []
}
